const PERSIST_PARAMS = ["product_tour_id"];

/**
 * Filters out search params that don't appear in the constant list.
 * @param {URLSearchParams} searchParams
 * @returns {URLSearchParams} filtered params
 */
export const persistParams = (searchParams) =>
  [...(searchParams?.entries() ?? [])].reduce((result, [key, value]) => {
    if (PERSIST_PARAMS.includes(key)) result.set(key, value);

    return result;
  }, new URLSearchParams());
